import type { ReactNode } from 'react';
import { useNavigate } from 'react-router-dom';

import { useAuth } from '../context/AuthContext';
import { useConfirm } from '../context/ConfirmContext';
import { JackpotWidget } from './jackpot/JackpotWidget';
import { Sidebar, type SidebarNavItem } from './Sidebar';

interface AppLayoutProps {
  navItems: SidebarNavItem[];
  logoAccent: string;
  children?: ReactNode;
}

/**
 * Khung trang chung. Trước đây `user-layout` và `admin-layout` là 2 file gần
 * như giống hệt — chỉ khác danh sách nav và chữ trên logo, nên gộp lại.
 */
export function AppLayout({ navItems, logoAccent, children }: AppLayoutProps) {
  const navigate = useNavigate();
  const { user, logout } = useAuth();
  const confirm = useConfirm();

  const handleLogout = async () => {
    const accepted = await confirm({
      title: 'Đăng xuất',
      message: 'Bạn có chắc chắn muốn đăng xuất?',
    });
    if (!accepted) return;

    await logout();
    navigate('/login', { replace: true });
  };

  return (
    <div className="bg-canvas flex h-screen overflow-hidden">
      <Sidebar
        navItems={navItems}
        logoText="Hit"
        logoAccent={logoAccent}
        userName={user?.username ?? ''}
        userRole={user?.role ?? ''}
        onLogout={() => {
          void handleLogout();
        }}
      />
      <main className="custom-scrollbar flex-1 overflow-y-auto p-6">
        <div className="mx-auto max-w-7xl">{children}</div>
      </main>
      {/* Widget báo hũ nổi — hiện trên mọi trang đã đăng nhập, tự ẩn nếu chưa cấu hình. */}
      <JackpotWidget />
    </div>
  );
}
